module.exports = __webpack_public_path__ + "static/media/embeded-testing.e91f87e3.svg";